import { render, staticRenderFns } from "./DashboardGrupoFornecedor.vue?vue&type=template&id=48770182&"
import script from "./DashboardGrupoFornecedor.vue?vue&type=script&lang=js&"
export * from "./DashboardGrupoFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports